<template>
  <el-dialog class="wallet" title="我的钱包" :visible.sync="visible" width="300px" :before-close="onClose">
    <div class="wallet-content">
      <!-- 上半区域 -->
      <div class="wallet-top">
        <i class="el-icon-money wallet-icon"></i>
<!--        <i class="el-icon&#45;&#45;yue"></i>-->
        <div class="wallet-balance-label">我的余额</div>
        <div class="wallet-balance-amount">
          <span class="currency-symbol">￥</span>{{ formattedBalance }}
        </div>
<!--        <el-alert  v-if="showAlert" type="info" :description="walletConfig.walletWithdrawMessage"></el-alert>-->
      </div>
      <!-- 下半区域 -->
      <div class="wallet-bottom">
        <el-button type="primary" @click="submitWithdraw">提现</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "wallet",
  components: {

  },
  data() {
    return {
      balance: 0,
      showAlert: false, // 控制提示框显示
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    // 点击提现
    submitWithdraw() {
      // this.showAlert = true;
      this.$message.warning(this.walletConfig.walletWithdrawMessage);
    },
    // 更新钱包余额的方法
    updateWalletBalance() {
      // 假设你有一个接口 `/api/getWalletBalance`
      this.$http.get('/user/balance').then(response => {
        if (response) {
          this.balance = response;
        }
      }).catch(error => {
        console.error("获取余额失败", error);
        this.$message.error("获取余额失败，请稍后再试");
      });
    }
  },
  props: {
    visible: {
      type: Boolean
    }
  },
  computed: {
    // 计算属性，确保获取最新的 walletConfig
    walletConfig() {
      return this.$store.state.configStore;
    },
    formattedBalance() {
      // 使用 toLocaleString 格式化金额，只保留整数部分
      return Math.floor(this.balance || 0).toLocaleString('zh-CN');
      // 使用 toLocaleString 格式化金额(带两位小数点)
      // return this.userInfo.balance.toLocaleString('zh-CN', {
      //   minimumFractionDigits: 2,
      //   maximumFractionDigits: 2,
      // })
    }
  },
  watch: {
    visible: function (newData) {
      // 每次打开弹窗的时候，更新钱包余额
      if(newData){
        this.updateWalletBalance()
      }
    }
  }
}
</script>

<style lang="scss">
.wallet {
  text-align: center;
}
.wallet-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 300px; /* 设置弹窗高度 */
}
.wallet-top {
  margin-bottom: 20px;
}
.wallet-icon {
  font-size: 40px;
  color: #f56c6c;
  margin-top: 10px;
}
.wallet-balance-label {
  font-size: 12px;
  margin-top: 30px;
}
.wallet-balance-amount {
  font-size: 36px;
  font-weight: bold;
  margin-top: 10px;
}
.wallet-bottom {
  margin-top: 80px;
}
.currency-symbol {
  position: relative;
  top: -8px; /* 上浮的偏移量，根据需要调整 */
  font-size: 0.7em;
}
</style>
